<template>
  <div v-if="text" class="flex items-center gap-1 mt-5">
    <Message icon="pi pi-exclamation-triangle" v-if="isWarning" severity="error">
        {{ text }}</Message>
    <Message v-else severity="warn">{{ text }}</Message>
  </div>
</template>

<script>
import { Message } from 'primevue';

export default {
  name: 'MessageBoxComponent',
  components: { Message },
  props: {
    text: String,
    isWarning: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
};
</script>
